let backendHost;
let hostAddress;
let membersSiteAddress;
const apiVersion = 'v1';
var useProdKeys = false

const hostname = window && window.location && window.location.hostname;

if(hostname === 'app.mycirrusdental.com') {
  backendHost = 'https://app.mycirrusdental.com';
  hostAddress = 'https://app.mycirrusdental.com';
  membersSiteAddress = 'https://member.mycirrusdental.com';
  useProdKeys = true
} else if(hostname === 'app-new.mycirrusdental.com') {
  // Custom domain for new Cloud Run deployment
  backendHost = 'https://api-new.mycirrusdental.com';
  hostAddress = 'https://app-new.mycirrusdental.com';
  membersSiteAddress = 'https://member.mycirrusdental.com';
  useProdKeys = true
} else if(hostname === 'cirrus-frontend-572064133419.us-east4.run.app') {
  // Cloud Run frontend default URL
  backendHost = 'https://cirrus-backend-572064133419.us-east4.run.app';
  hostAddress = 'https://cirrus-frontend-572064133419.us-east4.run.app';
  membersSiteAddress = 'https://member.mycirrusdental.com';
  useProdKeys = true
} else if(hostname === 'staging.mycirrusdental.com') {
  backendHost = 'https://staging.mycirrusdental.com';
  hostAddress = 'https://staging.mycirrusdental.com';
  membersSiteAddress = 'https://staging.member.mycirrusdental.com';
} else if(hostname === 'demo.mycirrusdental.com') {
  backendHost = 'https://demo.mycirrusdental.com';
  hostAddress = 'https://demo.mycirrusdental.com';
  membersSiteAddress = 'https://demo.member.mycirrusdental.com';
} else if(/^qa/.test(hostname)) {
  backendHost = `https://api.${hostname}`;
} else {
  // Development/localhost fallback
  backendHost = 'http://localhost:8000';
  hostAddress = 'http://localhost:3000';
  membersSiteAddress = 'http://localhost:4000';
}

export const API_ROOT = `${backendHost}/api/${apiVersion}`;
export const API_TOKEN_REFRESH = 54000;
export const SUPPORT_EMAIL = 'support@mycirrusdental.com'
export const COMPANY_WEB_SITE = 'https://www.mycirrusdental.com'
export const COMPANY_BLOG = 'https://www.mycirrusdental.com/blog'
export const COMPANY_NAME = 'Cirrus Dental'
export const SUPPORT_WEB_SITE = 'https://cirrusdental.zendesk.com'
export const DEFAULT_US_STATE = 'MA'
export const OTP_LENGTH = '6'
export const TEXT_MESSAGE_NOTE = 'We may occasionally send you text messages related to your use of ' + COMPANY_NAME + '. ' +
                                  'We will never share your phone number or use text messaging for marketing.'
export const EMAIL_NOTE = 'Changing your email address will change how we contact you, but it will not affect the ' +
                          'address you use to log in. We cannot change the email address you use to log in.'
export const SHOW_IN_SEARCH_NOTE = 'Unchecking this option means patients will be able to enroll only via an ' +
                                    'employer-sponsored subscription or invitation. If your information shows in search ' +
                                    'results, patients will be able to enroll via the ' + COMPANY_NAME + ' web site.'
export const CREDIT_CARD_FEE_NOTE = 'Accepting credit cards offers extra convenience to your patients. ' +
  'Credit card processing is done through our partner Stripe. ' +
  'Stripe charges a fee of 30 cents per transaction, ' +
  'plus 2.9% of the transaction amount.'
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCmkldvmoXXWfa-gmsIal3Wja0ov92sBkU'

var stripePublicKey
var stripeClientId
if (useProdKeys) {
  stripePublicKey = 'pk_live_47sAnCq5Rdb8pq3onPpXh3Gs002bxqdPxR'
  stripeClientId = 'ca_He9DQJFxRB8oYI8yFSy6PWnyvFZgFEMy'
} else {
  stripePublicKey = 'pk_test_1Nxypo7UdD5WfSLKs4QsQFFN000LBeMmPG'
  stripeClientId = 'ca_He9DusUEvylmh0TOVuEwb588irSnTYWn'
}
export const STRIPE_PUBLIC_KEY = stripePublicKey
export const STRIPE_CLIENT_ID = stripeClientId
export const MARKETING_PLAN_TEMPLATE_CODE = 'marketingDentist'

export const CREDIT_CARD_PROCESSOR = 'stripe'
export const STRIPE_CONNECT_URL = 'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write'
export const HOST_ADDRESS = hostAddress
export const MEMBER_SITE_ADDRESS = membersSiteAddress